import type { FunctionComponent } from 'react'
import styled from 'styled-components'

const StyledHr = styled.hr<{ gutter?: boolean; transparent?: boolean }>`
  height: 1px;
  margin-bottom: 0;
  margin-top: 0;
  border: none;
  box-sizing: content-box;
  overflow: visible;
  margin-left: ${(props) => (props.gutter ? '1rem' : '0')};
  margin-right: ${(props) => (props.gutter ? '1rem' : '0')};
  background-color: ${(props) => (props.transparent ? 'transparent' : '#b4b4b4')};
`

const Divider: FunctionComponent<{ gutter?: boolean; transparent?: boolean }> = ({
  gutter,
  transparent,
}) => <StyledHr gutter={gutter} transparent={transparent} />

export default Divider
